import React, { FocusEvent } from "react";
import { Col, Row } from "react-bootstrap";
import { ActionHandlerFunction, AdminApprovalGroup } from "@preveil-api";
import { AdminUIActionTypes, CheckboxStates, DriveUIActionTypes } from "src/common";
import { Checkbox } from "src/components";

type AllProps = {
  approval_group: AdminApprovalGroup;
  selected: boolean;
  handleAction: ActionHandlerFunction;
};

/* Description: Row component for each approval group in the list. */
function ListRowComponent(props: AllProps) {
  const { approval_group, selected, handleAction } = props;

  // Description: Handle the click of checkbox and changes of checkbox state
  function handleCheckboxChange(e: FocusEvent<HTMLInputElement>) {
    handleAction({ actionType: DriveUIActionTypes.Select, params: { selected: e.target.checked, approval_group }});
  }

  // Description: show side nav with the user details
  function handleRowClick() {
    handleAction({ actionType: AdminUIActionTypes.ShowSideNavMenu, params: { approval_group } });
  }

  return (
    <Row onClick={handleRowClick}>
      <Col md="1">
        <Checkbox
          onChange={(e: FocusEvent<HTMLInputElement>) => { handleCheckboxChange(e); }}
          value="approval group" label="Select Row"
          selected={selected ? CheckboxStates.checked : CheckboxStates.empty}
        />
      </Col>
      <Col md={4} className="col">{approval_group.name}</Col>
      <Col md={3}>{approval_group.approvers.length}</Col>
      <Col md={3}>{approval_group.required_approvers}</Col>
    </Row>
  );
}

export default React.memo(ListRowComponent);
